import React from "react";

export default function ReEnduranceIcon({ id, className, size, style }) {
  return (
    <svg
      width={size || 32}
      height={size || 32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} tbk-inline-block tbk-align-text-bottom`}
      style={style}
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <circle
        cx="16"
        cy="16"
        r="16"
        fill={`url(#${id}_paint0_linear_12669_13671)`}
      />
      <g clipPath={`${id}_clip0_12669_13671`}>
        <path
          d="M24.0811 14.9188C24.0623 14.5782 23.7436 14.325 23.3217 14.3219C22.7279 14.3188 22.1311 14.3157 21.5342 14.325C21.4029 14.325 21.3248 14.2875 21.2529 14.1719C20.8311 13.4907 20.3998 12.8157 19.9811 12.1344C19.7092 11.6907 19.3217 11.4719 18.8092 11.4719H14.5186C14.0967 11.4719 13.7623 11.6469 13.5154 11.9782C12.9498 12.7344 12.3873 13.4938 11.8279 14.2532C11.7592 14.3375 11.7029 14.4313 11.6561 14.5313C11.5623 14.7625 11.5779 14.9938 11.7529 15.1844C11.9279 15.375 12.1561 15.4407 12.3873 15.3407C12.5623 15.2688 12.7154 15.1532 12.8373 15.0094C13.3592 14.3407 13.8592 13.6563 14.3717 12.9782C14.4154 12.9188 14.4904 12.8438 14.5529 12.8407C14.9498 12.8282 15.3467 12.8313 15.7436 12.8375C15.8748 12.8407 15.9029 12.9282 15.8623 13.0375C15.8404 13.0875 15.8154 13.1375 15.7842 13.1813C15.4217 13.7938 15.0529 14.4032 14.6936 15.0157C14.4811 15.3657 14.3904 15.775 14.4279 16.1844C13.5029 17.6313 11.9904 19.9094 11.1061 21.3063C10.7467 21.8719 10.3873 22.4407 10.0311 23.0063C9.8967 23.2188 9.86857 23.4407 9.9967 23.6657C10.1186 23.8782 10.3061 23.9875 10.5498 23.9969C10.7779 23.9907 10.9498 23.8782 11.0873 23.7C12.3904 22.0219 14.2904 19.5125 15.6623 17.7375C15.6998 17.7563 15.7373 17.7782 15.7748 17.8C16.4654 18.1875 17.1623 18.5688 17.8936 18.9782C17.7936 19.0282 17.7342 19.0594 17.6717 19.0875C16.9623 19.4125 16.2498 19.7313 15.5436 20.0563C15.1873 20.2188 15.0436 20.5469 15.1686 20.8782C15.2936 21.2094 15.6279 21.3657 15.9936 21.2532C17.1092 20.9063 18.2248 20.5563 19.3404 20.2032C19.8186 20.0532 20.1029 19.7188 20.1686 19.2282C20.2342 18.7532 20.0467 18.3719 19.6498 18.1C19.3279 17.8782 19.0061 17.6625 18.6811 17.4438L17.4498 16.6063C17.4529 16.5782 17.4623 16.5532 17.4717 16.5282C17.9592 15.6938 18.4467 14.8625 18.9373 14.0313C19.0279 13.875 19.1061 13.8782 19.2092 14.0313C19.5029 14.4688 19.7967 14.9063 20.0873 15.3469C20.2404 15.5813 20.4561 15.7188 20.7342 15.7219C21.6092 15.7282 22.4873 15.7344 23.3623 15.7188C23.7904 15.7063 24.1029 15.3313 24.0811 14.9188Z"
          fill="#FDFF8C"
        />
        <path
          d="M19.6279 10.9938C20.4561 10.9969 21.1279 10.3281 21.1311 9.50314C21.1342 8.67814 20.4654 8.00314 19.6404 8.00001C18.8123 7.99689 18.1404 8.66564 18.1373 9.49064C18.1279 10.3125 18.7873 10.9875 19.6123 10.9938H19.6279Z"
          fill="#FDFF8C"
        />
      </g>
      <path
        d="M16 2C15.6702 2 15.4028 2.26736 15.4028 2.59714V5.15002C15.4028 5.4798 15.6702 5.74715 16 5.74715C16.3297 5.74715 16.5971 5.47988 16.5971 5.1501V2.59714C16.5971 2.26736 16.3297 2 16 2Z"
        fill="#FDFF8C"
      />
      <path
        d="M16 26.2527C15.6702 26.2527 15.4028 26.52 15.4028 26.8498V29.4027C15.4028 29.7325 15.6702 29.9998 16 29.9998C16.3297 29.9998 16.5971 29.7325 16.5971 29.4027V26.8498C16.5971 26.52 16.3297 26.2527 16 26.2527Z"
        fill="#FDFF8C"
      />
      <path
        d="M29.4029 15.4028H26.8501C26.5203 15.4028 26.2529 15.6702 26.2529 16C26.2529 16.3297 26.5203 16.5971 26.8501 16.5971H29.4029C29.7327 16.5971 30.0001 16.3297 30.0001 16C30.0001 15.6702 29.7327 15.4028 29.4029 15.4028Z"
        fill="#FDFF8C"
      />
      <path
        d="M5.15002 15.4028H2.59714C2.26736 15.4028 2 15.6702 2 16C2 16.3297 2.26736 16.5971 2.59714 16.5971H5.15002C5.4798 16.5971 5.74715 16.3297 5.74715 16C5.74715 15.6702 5.4798 15.4028 5.15002 15.4028Z"
        fill="#FDFF8C"
      />
      <path
        d="M5.79662 9.41977L4.6912 8.78155C4.40553 8.61658 4.0404 8.71451 3.87551 9.0001C3.71062 9.28569 3.80847 9.6509 4.09406 9.81579L5.19948 10.454C5.29351 10.5083 5.39622 10.5341 5.49749 10.5341C5.70386 10.5341 5.90458 10.4269 6.01517 10.2355C6.18006 9.94987 6.08221 9.58466 5.79662 9.41977Z"
        fill="#FDFF8C"
      />
      <path
        d="M27.906 22.1844L26.8006 21.5462C26.515 21.3812 26.1498 21.4792 25.9849 21.7648C25.82 22.0503 25.9178 22.4156 26.2034 22.5804L27.3089 23.2187C27.4029 23.273 27.5056 23.2988 27.6069 23.2988C27.8132 23.2988 28.014 23.1916 28.1245 23.0001C28.2894 22.7145 28.1916 22.3493 27.906 22.1844Z"
        fill="#FDFF8C"
      />
      <path
        d="M23.0003 3.87579C22.7147 3.71082 22.3495 3.80875 22.1846 4.09434L21.5464 5.19976C21.3815 5.48535 21.4794 5.85056 21.765 6.01545C21.859 6.06975 21.9617 6.09555 22.063 6.09555C22.2693 6.09555 22.4701 5.98838 22.5807 5.7969L23.2189 4.69148C23.3838 4.40589 23.2859 4.04068 23.0003 3.87579Z"
        fill="#FDFF8C"
      />
      <path
        d="M10.2352 25.9847C9.94951 25.8197 9.5843 25.9176 9.41949 26.2032L8.78127 27.3086C8.61638 27.5942 8.71423 27.9594 8.99982 28.1243C9.09385 28.1786 9.19656 28.2044 9.29783 28.2044C9.50421 28.2044 9.70492 28.0973 9.81551 27.9058L10.4537 26.8004C10.6186 26.5148 10.5208 26.1496 10.2352 25.9847Z"
        fill="#FDFF8C"
      />
      <path
        d="M28.1245 9.00007C27.9597 8.71448 27.5944 8.61663 27.3089 8.78152L26.2034 9.41973C25.9178 9.58462 25.82 9.94983 25.9849 10.2354C26.0955 10.427 26.2962 10.5341 26.5026 10.5341C26.6038 10.5341 26.7065 10.5083 26.8006 10.454L27.906 9.81576C28.1916 9.65087 28.2894 9.28566 28.1245 9.00007Z"
        fill="#FDFF8C"
      />
      <path
        d="M6.01517 21.7645C5.85028 21.4789 5.48507 21.381 5.19948 21.546L4.09406 22.1842C3.80847 22.3491 3.71062 22.7143 3.87551 22.9999C3.9861 23.1914 4.18682 23.2985 4.39319 23.2985C4.49446 23.2985 4.59717 23.2727 4.6912 23.2184L5.79662 22.5802C6.08221 22.4154 6.18006 22.0502 6.01517 21.7645Z"
        fill="#FDFF8C"
      />
      <path
        d="M10.4537 5.19978L9.81551 4.09436C9.65062 3.80869 9.28541 3.71084 8.99982 3.87581C8.71423 4.0407 8.61638 4.4059 8.78127 4.6915L9.41949 5.79692C9.53008 5.98848 9.7308 6.09556 9.93717 6.09556C10.0384 6.09556 10.1412 6.06977 10.2352 6.01547C10.5208 5.85058 10.6186 5.48537 10.4537 5.19978Z"
        fill="#FDFF8C"
      />
      <path
        d="M23.2189 27.3086L22.5807 26.2032C22.4158 25.9176 22.0506 25.8197 21.765 25.9847C21.4794 26.1496 21.3815 26.5148 21.5464 26.8004L22.1846 27.9058C22.2952 28.0973 22.4959 28.2044 22.7023 28.2044C22.8036 28.2044 22.9063 28.1786 23.0003 28.1243C23.2859 27.9594 23.3838 27.5942 23.2189 27.3086Z"
        fill="#FDFF8C"
      />
      <defs>
        <linearGradient
          id={`${id}_paint0_linear_12669_13671`}
          x1="21.5"
          y1="0.999999"
          x2="9"
          y2="30.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA800" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <clipPath id={`${id}_clip0_12669_13671`}>
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(9 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
